import React from 'react'
import moment from "moment";
import { useNavigate } from "react-router-dom";
import favIcon from "../../Assets/favicon.ico"
import { NavigationHelper } from './NavigationHelper';
import { registerPath } from '../../Site/SiteCards';
import { formatDate } from '../../helper/formatDate';
import FeedPill from '../EventFeed/FeedPill';
import NowLinks from '../EventFeed/NowLinks';


const WebCard = ({ event, from, isHomePage, feedState, resultsTab }) => {
    const navigate = useNavigate()

    const isOireachtas = event?.eventType === "Oireachtas";
    let eventDate = event?.eventType === "Feiseanna" ? event?.feis_date : isOireachtas ? event?.eventDays?.[0] : event?.exam_date;
    // Oireachtas registration is teacher-only (parents get the read-only event
    // page), so a parent's card offers details rather than "Register".
    const isTeacher = localStorage.getItem("isTeacher") === "true";
    const registerBtn = isOireachtas && !isTeacher ? "View Details" : isHomePage ? "Register Now" : "Register"
    const btnName = from === "open" ? registerBtn : from === "closed" ? "Event Details" : from === "result" ? " View Results" : "View Details"
    // feedState (home feed only): "late" shows the late-entry close instead.
    const isLate = feedState === "late" && event?.lateEntryCloseDate
    const registrationDetailDate = isLate ? event?.lateEntryCloseDate : from === "upcoming" ? event?.opening_date : event?.closing_date
    const registrationDetail = from === "open" ? "closes" : from === "closed" ? "closed" : from === "result" ? "closed" : "starts"
    // happening now: live results, competitor lists and schedule instead of
    // one button; registration is long over, so its date is left off
    const isNow = feedState === "today"

    const goToViewEvent = (event) => {
        NavigationHelper(event, from, navigate, resultsTab);
    };

    // Register opens registration itself (Devin 2026-10-16), as on the
    // public home cards; the card body still opens the event page.
    const onButton = () => {
        if (from === "open" && !isOireachtas) navigate(registerPath(event), { state: { event } });
        else NavigationHelper(event, from, navigate, resultsTab);
    };

    return (
        <>
            <div className="web-events-list" onClick={() => goToViewEvent(event)} >
                <img src={event?.logo || favIcon} className="event-img" alt="logo" />
                <div className="event-details" >
                    <p className="title m-0">{event.eventType === "Feiseanna" ? "Feisanna" : isOireachtas ? "Oireachtas" : "Grade Exam"}<FeedPill state={feedState} /></p>
                    <p className="event-name m-0">{event.name} </p>
                    <p className="reg-date mt-2   ">
                        {eventDate ? moment(formatDate(eventDate)).format(" MMMM Do, YYYY") : "NA"}{" "}- {event.venue_city}, {event.state}
                    </p>
                </div>
                {!isNow && <div className="registrationDetails">
                    <p className="reg-date reg-name">{isLate ? "Late entries until :" : `Registration ${registrationDetail} :`} </p>
                    <p className="reg-date-close m-0">
                        {registrationDetailDate ? moment(formatDate(registrationDetailDate)).format("MMM Do, YYYY") : "NA"}
                    </p>
                </div>}
            </div>
            {isNow ? <NowLinks event={event} btnClass="web-btn" /> : (
                <button className="web-btn filled" onClick={() => onButton()}>
                    {btnName}
                </button>
            )}
        </>
    )
}

export default WebCard